import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import aa36faf64019b3f4afe080ae6f0e6c2e8b from "./generated-ffae4c2f-62ba-4a1f-8fa2-0f0f9a78fa8a.json";

import aee3e044b12e65db1416b8013593e7e06b from "./generated-b49ce743-a612-4f87-ad02-f3aea80b35a2.json";

import ac66ce66c62b99e574e8bc92e186a6f8cb from "./generated-e7c69abb-2b47-41a0-a5dd-9738e30e9947.json";

import ae916f717fd90b5e5007051695e9d0634b from "./generated-7b0a8563-dac7-45ab-8a64-39989aa9c071.json";

import a18707520523075abbc9ad79e96c7074bb from "./generated-dbb506f1-8f5e-4f2c-ab78-d49fe78ea52e.json";

import a9f63656d92e56307125d73dcae1a8cd1b from "./generated-a0509e50-d944-4606-a22e-11eefab95f0b.json";

import a0b25bd7d194dedc74c345405823cc257b from "./generated-d40c780e-4e94-4385-8f28-9219da7b9b46.json";

import ae7983c300f26bca90b7c804cf7cfd0f7b from "./generated-c7ac41ad-2264-427e-829d-b631a14f6ff2.json";

import a05fdb26b4b5ee9ee75fff5685ad1a835b from "./generated-e619bad1-2899-45ef-b7c8-dec82654b0da.json";

import a5b2a1a6f6690b9ca1fa7263a60753b69b from "./generated-b956ebc6-adcb-43aa-b797-558951e8d8a9.json";

import ad67d8304d1b0c13d7b3f8dc69fab0808b from "./generated-ad14e33f-f7d6-47bb-9261-98febafa6766.json";

import a1b0c849019a5a846c9b94aaa06ae0364b from "./generated-d681b926-ac7f-4d47-8954-f9baeda642dd.json";

import ad6a31d43ba35b11aff10f7ee5f69463ab from "./generated-10e5c37a-4e55-43c0-a1b5-ccc327ff9de4.json";

import a9f3aa0eb5c46d1b344b7da527ec55abbb from "./generated-841e4cf1-1da3-4556-b6f9-f6c9464567fe.json";

import a44b393ed3adb378772a4b36ce4d7a7beb from "./generated-8c178f90-19ac-4f7b-b274-ea587d23d0ed.json";

import a1b538d0ffebbb6e8ebb4e782d89cfc8bb from "./generated-f6f914c7-c422-4d84-ad85-a9503fe2f052.json";

import a6616e90fade3a2e0a417ce8c4819b64db from "./generated-1bc41a33-35a1-46ca-a200-85db9fcb0c45.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(aa36faf64019b3f4afe080ae6f0e6c2e8b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aee3e044b12e65db1416b8013593e7e06b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ac66ce66c62b99e574e8bc92e186a6f8cb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ae916f717fd90b5e5007051695e9d0634b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a18707520523075abbc9ad79e96c7074bb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a9f63656d92e56307125d73dcae1a8cd1b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a0b25bd7d194dedc74c345405823cc257b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ae7983c300f26bca90b7c804cf7cfd0f7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a05fdb26b4b5ee9ee75fff5685ad1a835b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a5b2a1a6f6690b9ca1fa7263a60753b69b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ad67d8304d1b0c13d7b3f8dc69fab0808b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a1b0c849019a5a846c9b94aaa06ae0364b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a05fdb26b4b5ee9ee75fff5685ad1a835b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ad6a31d43ba35b11aff10f7ee5f69463ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a9f3aa0eb5c46d1b344b7da527ec55abbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a05fdb26b4b5ee9ee75fff5685ad1a835b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a44b393ed3adb378772a4b36ce4d7a7beb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a1b538d0ffebbb6e8ebb4e782d89cfc8bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a6616e90fade3a2e0a417ce8c4819b64db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a44b393ed3adb378772a4b36ce4d7a7beb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */